/**
 * Per-thread imagery for the home chat mock (local /public files).
 *
 * Plan covers (Pexels, same order as `threads` in locales):
 * 0 outdoor social · 1 cycling · 2 studio stretch · 3 Korean table · 4 sunset landscape
 * — swap JPGs in /public/images/home-redesign/chat/plans/ to tune vibe.
 *
 * Faces: 15 small JPGs in /faces/ — `randomuser.me` **women** portrait set (guaranteed female avatars for the mock).
 */
export const CHAT_THREAD_VISUALS = [
  {
    cover: '/images/home-redesign/chat/plans/0-terrace.jpg',
    faces: {
      m: '/images/home-redesign/chat/faces/0-m.jpg',
      l: '/images/home-redesign/chat/faces/0-l.jpg',
      a: '/images/home-redesign/chat/faces/0-a.jpg',
    },
  },
  {
    cover: '/images/home-redesign/chat/plans/1-bike.jpg',
    faces: {
      m: '/images/home-redesign/chat/faces/1-m.jpg',
      l: '/images/home-redesign/chat/faces/1-l.jpg',
      a: '/images/home-redesign/chat/faces/1-a.jpg',
    },
  },
  {
    cover: '/images/home-redesign/chat/plans/2-barre.jpg',
    faces: {
      m: '/images/home-redesign/chat/faces/2-m.jpg',
      l: '/images/home-redesign/chat/faces/2-l.jpg',
      a: '/images/home-redesign/chat/faces/2-a.jpg',
    },
  },
  {
    cover: '/images/home-redesign/chat/plans/3-korean.jpg',
    faces: {
      m: '/images/home-redesign/chat/faces/3-m.jpg',
      l: '/images/home-redesign/chat/faces/3-l.jpg',
      a: '/images/home-redesign/chat/faces/3-a.jpg',
    },
  },
  {
    cover: '/images/home-redesign/chat/plans/4-sunset.jpg',
    faces: {
      m: '/images/home-redesign/chat/faces/4-m.jpg',
      l: '/images/home-redesign/chat/faces/4-l.jpg',
      a: '/images/home-redesign/chat/faces/4-a.jpg',
    },
  },
] as const;
